export const prepareFreetextValuesForSubmit = (values: {
    freetext: { body: Array<{ value: string }>; offers: Array<{ value: string }> };
}) => {
    const freeTextsBody = values.freetext.body.map(({ value }) => value);
    const freeTextsOffers = values.freetext.offers.map(({ value }) => value);

    return [freeTextsBody, freeTextsOffers];
};
